import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Button,
  Box,
} from "@mui/material";
import ChooseSignerModal from "../components/searchUnpaid/ChooseSignerModal";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

export default function SearchUnpaid() {
  const [year, setYear] = useState("");
  const [debt, setDebt] = useState(null);
  const [dataSubmitted, setDataSubmitted] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [enableSearch, setEnableSearch] = useState(false);
  const { loading, setLoading, notification, setNotification } =
    useAuthContext();
  const navigate = useNavigate();

  const [openSignerModal, setOpenSignerModal] = useState(false);
  const [signer, setSigner] = useState({ id: null, value: "" });

  const { setLoggedInUser } = useAuthContext();
  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/getListOfYears`,
          {
            withCredentials: true,
          },
        );

        setLoading(false);
        setResponseData(response.data);
      } catch (error) {
        setLoading(false);
        setNotification({
          message: error.response.data.message,
          open: true,
          color: "error",
        });
        if (error.response.status == 401) {
          setLoggedInUser(null);
          navigate("/login");
        }
        console.error(error);
      }
    })();
  }, []);

  useEffect(() => {
    if (year !== "") {
      setEnableSearch(true);
    } else {
      setEnableSearch(false);
    }
  }, [year]);

  const clearStates = () => {
    setDataSubmitted(null);
    setYear("");
    setDebt(null);
  };

  const handleSearch = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/getUnpaidSubscriptions`,
        { year },
        { withCredentials: true },
      );

      setLoading(false);
      setDataSubmitted({ year });

      setDebt({
        sum: response.data.debt?.toLocaleString(),
        amount: response.data.amount
          ? response.data.amount.toLocaleString()
          : 0,
      });
    } catch (error) {
      setLoading(false);
      setNotification({
        message: error.response.data.message,
        open: true,
        color: "error",
      });
      if (error.response.status == 401) {
        setLoggedInUser(null);
        navigate("/login");
      }
      console.log(error);
    }
  };

  const handleConfirmation = async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/createConfirmations`,
        {
          year: dataSubmitted.year,
          signerId: signer.id,
        },
        { withCredentials: true },
      );

      setLoading(false);
      clearStates();

      const message = `Στάλθηκαν για βεβαίωση ${response.data} εγγραφές`;
      setNotification({ message: message, open: true, color: "success" });
    } catch (error) {
      setLoading(false);
      setNotification({
        message: error.response.data.message,
        open: true,
        color: "error",
      });

      if (error.response.status == 401) {
        setLoggedInUser(null);
        navigate("/login");
      }
      console.log(error);
    }
  };

  return (
    <>
      {responseData ? (
        <Box>
          <Box
            sx={{
              textAlign: { xs: "center", md: "start" },
              marginTop: "5em",
              marginLeft: { xs: "0em", md: "5em" },
              marginBottom: "5em",
            }}
          >
            <h2>Αναζήτηση και Βεβαίωση Απλήρωτων Οφειλών</h2>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              width: "90vw",
              margin: "auto",
              gap: "1em",
            }}
          >
            <FormControl
              required
              sx={{
                width: { xs: "50%", md: "20%" },
              }}
            >
              <InputLabel id="demo-simple-select-label">Έτος</InputLabel>
              <Select
                value={year}
                label="year"
                fullWidth
                onChange={(event) => {
                  setYear(event.target.value);
                }}
              >
                {responseData.years.map((year, index) => (
                  <MenuItem key={index} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box
              sx={{
                margin: "1em",
              }}
            >
              <Button
                variant="contained"
                disabled={!enableSearch || loading}
                onClick={() => {
                  handleSearch();
                }}
              >
                {loading ? "Περιμένετε..." : "Αναζήτηση"}
              </Button>
            </Box>
            {debt !== null && dataSubmitted && (
              <Box
                className="unpaid-sub-result"
                sx={{
                  flexDirection: "column",
                }}
              >
                {debt.sum != 0 ? (
                  <>
                    <p>
                      Βρέθηκαν
                      <b> {debt.sum}</b> απλήρωτες οφειλές το έτος
                      <b> {dataSubmitted.year}</b> ύψους{" "}
                      <b>{debt.amount}&euro;</b>. Πατήστε Συνέχεια για βεβαίωση.
                    </p>
                    <Button
                      variant="contained"
                      disabled={loading}
                      onClick={() => {
                        setOpenSignerModal(true);
                      }}
                    >
                      {loading ? "Περιμένετε..." : "Συνέχεια"}
                    </Button>
                  </>
                ) : (
                  <p>
                    Δεν βρέθηκαν
                    <> απλήρωτες</> οφειλές που να μήν έχουν οδηγηθεί για
                    βεβαίωση το έτος
                    <b> {dataSubmitted.year}</b>
                  </p>
                )}
              </Box>
            )}
          </Box>
        </Box>
      ) : (
        <Box height="100%"></Box>
      )}
      <ChooseSignerModal
        signer={signer}
        setSigner={setSigner}
        handleConfirmation={handleConfirmation}
        open={openSignerModal}
        setOpen={setOpenSignerModal}
      />
    </>
  );
}
